import _moment from 'moment'

export default {
  pluralize(amount, singular, plural = null) {
    if (plural === null) {
      plural = `${singular}s`
    }
    return amount > 1 || amount === 0 ? plural : singular
  },
  capitalize(string) {
    return string[0].toUpperCase() + string.slice(1)
  },
  moment(date, _format) {
    return _moment(date).format(_format)
  },
  parseSubscriptionStatus(_status) {
    switch (_status) {
      case _status === true:
        return 'ATIVA'
      default:
        return 'INATIVA'
    }
  }
}
